import clsx from 'clsx'

import type { DeliveryPointItem } from '@/entities/order/types/delivery'

import { ShopCard } from '../shops-card/shop-card'

import cls from './shops-list.module.scss'

type ShopsListProps = {
	className?: string
	items: DeliveryPointItem[]
	onSelect?: (point: DeliveryPointItem) => void
}

export const ShopsList = (props: ShopsListProps) => {
	const { items, onSelect, className } = props

	return (
		<div className={clsx(cls.root, className)}>
			{items.map(item => (
				<ShopCard
					key={item.DELIVERY_PVZ_CODE}
					metro={item.METRO_LINE}
					address={item.ADDRESS}
					postamat={item.POSTAMAT}
					storagePeriod={item.STORAGE_PERIOD}
					workShedule={item.WORK_SHEDULE}
					partner={item.DELIVERY_PVZ_PARTNER}
					onSelect={() => onSelect?.(item)}
				/>
			))}
		</div>
	)
}
